import { EventosServiceAdapter } from "@/usecases";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";
import { findAll } from '@/api/eventos'

@injectable()
export class EventosService implements EventosServiceAdapter {

	findAll = async (params?: any, config?: AxiosRequestConfig) => await findAll(params, config)

}